import type { FunctionComponent, ReactNode } from 'react';

import { TrophyDisplayData } from '../../../store/slices/promotions/types';
import { L12nText } from '../../text/L12nText';
import { GameWing } from '../gameWing/GameWing';
import { DirectionProps, GameWingItem } from '../gameWingItem/GameWingItem';

export interface TotalBetWingProps {
  totalBet: ReactNode;
  trophy?: TrophyDisplayData;
}

export const TotalBetWing: FunctionComponent<TotalBetWingProps> = ({ totalBet, trophy }) => {
  return (
    <GameWing direction={DirectionProps.end}>
      <GameWingItem
        dataTestId="total-bet"
        direction={DirectionProps.end}
        trophy={trophy}
        label={<L12nText tk="BET" />}
        value={totalBet}
        isLabelAlignedRight={true}
      />
    </GameWing>
  );
};
